// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ZuRcY","footer":"styles_footer__-Xe9u","passCodeTooltip":"styles_passCodeTooltip__2JznC"};